import Vue from 'vue';

import VueLazyload from 'vue-lazyload';
import { Affix } from 'vue-affix';
import WebFontLoader from 'webfontloader';
import VueScrollactive from 'vue-scrollactive';
import AOS from 'aos';

import Accordion from '@/components/accordion';
import BlockForm from '@/components/blocks/block-form';
import BlockBrochure from '@/components/blocks/block-brochure';
import BlockIframe from '@/components/blocks/block-iframe';
import BlockRelatedEducations from '@/components/blocks/block-related-educations';
import BlockSlider from '@/components/blocks/block-slider';
import BlockTrending from '@/components/blocks/block-trending';
import BouncyArrow from '@/components/bouncy-arrow';
import Cookiebar from '@/components/cookies/cookiebar';
import CookieModal from '@/components/cookies/cookie-modal';
import FavoriteButton from '@/components/favorite-button';
import EducationOverview from '@/components/education/education-overview';
import EducationFavorites from '@/components/education/education-favorites';
import HomeSearch from '@/components/search/home-search';
import HomepageHeaderInfo from '@/components/homepage/homepage-header-info';
import HomepageStatistic from '@/components/homepage/homepage-statistic';
import HomepageSearchResults from '@/components/homepage/homepage-search-results';
import LazyBackground from '@/components/lazy-background';
import LazyImage from '@/components/lazy-image';
import NavBar from '@/components/nav/navbar';
import NavigationBullets from '@/components/nav/navigation-bullets';
import NewsOverview from '@/components/news/news-overview';
import BlogsOverview from '@/components/news/blogs-overview';
import SearchResults from '@/components/search/search-results';
import TextPage from '@/components/textPage/text-page';
import BlockInformationRequest from '@/components/blocks/block-information-request';
import BlockComplaints from '@/components/blocks/block-complaints';
import BlockTopEducations from '@/components/blocks/block-top-educations';
import BlockActionHeader from '@/components/blocks/block-action-header';
import BlockLostDiploma from '@/components/blocks/block-lost-diploma';
import BlockSignupForm from '@/components/blocks/block-signup-form';
import BlockDiplomaStatement from '@/components/blocks/block-diploma-statement';
import BlockVavoOpenDay from '@/components/blocks/block-vavo-open-day';
import BlockFinancialSupport from '@/components/blocks/block-financial-support';
import BlockCards from '@/components/blocks/block-cards';
import VacancyDetail from '@/components/vacancy-detail';

import store from '@/js/store/store';
import router from '@/js/router/router.js';
import '@/js/helpers/forms.validate.js';
import '@/scss/main.scss';
import sentry from './js/plugins/sentry';
sentry.init(window.settings.environment, window.settings.sentryDSN);

Vue.config.productionTip = false;

Vue.use(VueLazyload, {
    filter: {
        webp(listener, options) {
            if (
                options.supportWebp &&
                (typeof listener.src !== 'undefined' &&
                    listener.src !== null) &&
                (typeof listener.el.dataset['webp'] !== 'undefined' &&
                    listener.el.dataset['webp'] !== null)
            ) {
                listener.src = listener.el.dataset['webp'];
            }
        }
    }
});

Vue.use(VueScrollactive);

AOS.init({
    easing: 'ease-out-quad'
});

window.app = new Vue({
    el: '#app',
    store,
    router,
    components: {
        Accordion,
        BouncyArrow,
        BlockForm,
        BlockBrochure,
        BlockIframe,
        BlockRelatedEducations,
        BlockComplaints,
        BlockSlider,
        BlockTrending,
        BlockVavoOpenDay,
        Cookiebar,
        CookieModal,
        EducationOverview,
        EducationFavorites,
        FavoriteButton,
        HomepageHeaderInfo,
        HomepageStatistic,
        HomepageSearchResults,
        HomeSearch,
        LazyBackground,
        LazyImage,
        NavBar,
        NavigationBullets,
        NewsOverview,
        BlogsOverview,
        SearchResults,
        Affix,
        TextPage,
        BlockInformationRequest,
        BlockLostDiploma,
        BlockDiplomaStatement,
        BlockTopEducations,
        BlockActionHeader,
        BlockFinancialSupport,
        BlockSignupForm,
        BlockCards,
        VacancyDetail
    },
    data: {
        settings: {},
        cookieDialog: false
    },

    beforeCreate() {
        this.$store.commit('initialiseStore');
    },

    created() {
        this.settings = window.settings;
        WebFontLoader.load({
            custom: {
                families: [
                    'Helvetica Neue Pro Condensed',
                    'Helvetica Neue Pro'
                ],
                urls: ['/content/fonts/_fonts.css']
            }
        });
    },

    mounted() {
        const state = setInterval(() => {
            if (
                document.readyState === 'interactive' ||
                document.readyState === 'complete'
            ) {
                this.$el.classList.remove('preloader--loading');
                clearInterval(state);
            }
        }, 100);
    }
});
